<div class="card card-redlaboral m-4">
    <div class="card-body">
        <div class="row mb-3">
            <div class="col-12">
                <h4 class="mt-0 mb-1 text-primary">Aprobación Previa a Pago</h4>
                <p class="text-muted mb-0">
                    Gestiona solicitudes, decisiones y ventanas de pago para ítems que requieren aprobación.
                </p>
            </div>
        </div>

        <hr class="mt-3 mb-3" />

        <div class="section">
            <h5 class="section-title">Solicitudes Pendientes</h5>

            <div class="row align-items-end mb-3">
                <div class="col-md-2">
                    <label class="form-label">Buscar</label>
                    <input class="form-control" type="text" [(ngModel)]="filterValue"
                        placeholder="Usuario, correo, título, plan." />
                </div>

                <div class="col-md-2">
                    <label class="form-label">Filtrar por</label>
                    <select class="form-select" [(ngModel)]="filterKey">
                        <option value="">Seleccione un filtro</option>
                        <option value="userName">Usuario</option>
                        <option value="userEmail">Correo</option>
                        <option value="title">Título</option>
                        <option value="plan">Plan</option>
                    </select>
                </div>

                <div class="col-md-2">
                    <label class="form-label fw-semibold">Desde</label>
                    <input type="date" class="form-control" [(ngModel)]="filterStartDate" />
                </div>
                <div class="col-md-2">
                    <label class="form-label fw-semibold">Hasta</label>
                    <input type="date" class="form-control" [(ngModel)]="filterEndDate" />
                </div>
                <div class="col-md-4 text-end mt-3 mt-md-0">
                    <button class="btn btn-primary me-2" (click)="applyFilters()" title="Buscar">
                        <i class="fa-solid fa-magnifying-glass"></i>
                    </button>
                    <button class="btn btn-outline-secondary" (click)="clearFilters()" title=" Limpiar Filtro">
                        <i class="fa-solid fa-eraser"></i>
                    </button>
                </div>
            </div>

            @if (isLoading()) {
            <div class="d-flex justify-content-center my-4">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando solicitudes...</span>
                </div>
            </div>
            } @else if (pendingRequests().length === 0) {
            <div class="empty-state">
                <i class="fa-solid fa-info-circle me-2"></i>
                No hay solicitudes pendientes
            </div>
            } @else {
            <div class="table-responsive">
                <table class="table table-theme align-middle">
                    <thead class="table-light">
                        <tr>
                            <th>FECHA SOLICITUD</th>
                            <th>USUARIO</th>
                            <th>ÍTEM SOLICITADO</th>
                            <th class="text-center">CANTIDAD</th>
                            <th class="text-center">TOTAL A PAGAR</th>
                            <th class="text-center">ACCIONES</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (request of pendingRequests(); track request.requestId) {
                        <tr>
                            <td>{{ request.createdAt | date : 'dd/MM/yyyy hh:mm a' }}</td>
                            <td>
                                <div class="fw-semibold">{{ request.requestedByName }}</div>
                                <div class="small text-muted">{{ request.requestedByEmail }}</div>
                            </td>
                            <td>
                                <div class="fw-semibold">{{ request.itemTitle }}</div>
                                @if (request.planName) {
                                <div class="small text-muted">{{ request.planName }}</div>
                                }
                            </td>
                            <td class="text-center">{{ request.quantityRequested | number}}</td>
                            <td class="text-center">{{ request.reservationPrice | currency }}</td>
                            <td class="text-center">
                                <div class="d-flex justify-content-center gap-3">
                                    <button class="btn btn-approve" (click)="approveRequest(request)">
                                        <i class="fa-solid fa-check me-2"></i> Aprobar
                                    </button>

                                    <button class="btn btn-reject" (click)="rejectRequest(request)">
                                        <i class="fa-solid fa-xmark me-2"></i> Rechazar
                                    </button>
                                </div>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>

            @if (pendingTotal() > 0) {
            <app-pagination [page]="pendingPage()" [pageSize]="pendingPageSize()" [totalItems]="pendingTotal()"
                (pageChange)="onPendingPageChange($event)" (pageSizeChange)="onPendingPageSizeChange($event)">
            </app-pagination>
            }
            }
        </div>

        <hr class="mt-4 mb-4" />

        <div class="section">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="section-title mb-0">Historial de Decisiones</h5>
            </div>

            <div class="row align-items-end mb-3">
                <div class="col-md-2">
                    <label class="form-label">Buscar</label>
                    <input class="form-control" type="text" [(ngModel)]="filterTapValue"
                        placeholder="Usuario, correo, título, plan." />
                </div>

                <div class="col-md-2">
                    <label class="form-label">Filtrar por</label>
                    <select class="form-select" [(ngModel)]="filterTapKey">
                        <option value="">Seleccione un filtro</option>
                        <option value="userName">Usuario</option>
                        <option value="userEmail">Correo</option>
                        <option value="title">Título</option>
                        <option value="plan">Plan</option>
                    </select>
                </div>

                <div class="col-md-2">
                    <label class="form-label fw-semibold">Desde</label>
                    <input type="date" class="form-control" [(ngModel)]="filterTapStartDate" />
                </div>
                <div class="col-md-2">
                    <label class="form-label fw-semibold">Hasta</label>
                    <input type="date" class="form-control" [(ngModel)]="filterTapEndDate" />
                </div>
                <div class="col-md-4 text-end mt-3 mt-md-0">
                    <button class="btn btn-primary me-2" (click)="applyTapFilters()" title="Buscar">
                      <i class="fa-solid fa-magnifying-glass"></i>
                    </button>
                    <button class="btn btn-outline-secondary" (click)="clearTapFilters()" title="Limpiar Filtro">
                        <i class="fa-solid fa-eraser"></i>
                    </button>
                </div>
            </div>

            <ul class="nav nav-tabs mb-3">
                <li class="nav-item">
                    <button class="nav-link" [class.active]="selectedTab() === 'approved'"
                        (click)="selectTab('approved')">
                        Aprobadas (Esperando Pago)
                    </button>
                </li>
                <li class="nav-item">
                    <button class="nav-link" [class.active]="selectedTab() === 'completed'"
                        (click)="selectTab('completed')">
                        Completadas
                    </button>
                </li>
                <li class="nav-item">
                    <button class="nav-link" [class.active]="selectedTab() === 'rejected'"
                        (click)="selectTab('rejected')">
                        Solicitudes Rechazadas
                    </button>
                </li>
                <li class="nav-item">
                    <button class="nav-link" [class.active]="selectedTab() === 'expired'"
                        (click)="selectTab('expired')">
                        Expiradas
                    </button>
                </li>
            </ul>

            <div class="tab-content">

                @if (selectedTab() === 'approved') {
                <div class="approved-content">
                    @if (approvedLoading()) {
                    <div class="d-flex justify-content-center my-4">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Cargando aprobadas...</span>
                        </div>
                    </div>
                    } @else if (approvedRequests().length === 0) {
                    <div class="empty-state">
                        <i class="fa-solid fa-info-circle me-2"></i>
                        No hay solicitudes aprobadas esperando pago
                    </div>
                    } @else {
                    <div class="table-responsive">
                        <table class="table table-theme align-middle">
                            <thead class="table-light">
                                <tr>
                                    <th>USUARIO</th>
                                    <th>ÍTEM</th>
                                    <th class="text-center">CANTIDAD</th>
                                    <th class="text-center">TOTAL A PAGAR</th>
                                    <th>APROBADO POR</th>
                                    <th>ENLACE DE PAGO</th>
                                    <th class="text-center">VENTANA RESTANTE</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (request of approvedRequests(); track request.requestId) {
                                <tr>
                                    <td>
                                        <div class="fw-semibold">{{ request.requestedByName }}</div>
                                        <div class="small text-muted">{{ request.requestedByEmail }}</div>
                                    </td>
                                    <td>
                                        <div class="fw-semibold">{{ request.itemTitle }}</div>
                                        @if (request.planName) {
                                        <div class="small text-muted">{{ request.planName }}</div>
                                        }
                                    </td>
                                    <td class="text-center">{{ request.quantityRequested | number}}</td>
                                    <td class="text-center">{{ request.reservationPrice | currency }}</td>
                                    <td>{{ request.approvedByEmail || 'N/A' }}</td>
                                    <td>
                                        <a class="text-decoration-none text-primary">/pay/{{ request.paymentCode }}</a>
                                    </td>

                                    <td class="text-center">
                                        <app-payment-timer [expiresAt]="request.expiresAt"></app-payment-timer>
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                    @if (approvedTotal() > 0) {
                    <app-pagination [page]="approvedPage()" [pageSize]="approvedPageSize()"
                        [totalItems]="approvedTotal()" (pageChange)="onApprovedPageChange($event)"
                        (pageSizeChange)="onApprovedPageSizeChange($event)">
                    </app-pagination>
                    }
                    }
                </div>
                }

                @else if (selectedTab() === 'completed') {
                <div class="completed-content">
                    @if (completedLoading()) {
                    <div class="d-flex justify-content-center my-4">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Cargando completadas...</span>
                        </div>
                    </div>
                    } @else if (completedRequests().length === 0) {
                    <div class="empty-state">
                        <i class="fa-solid fa-info-circle me-2"></i>
                        No hay solicitudes completadas
                    </div>
                    } @else {
                    <div class="table-responsive">
                        <table class="table table-theme align-middle">
                            <thead class="table-light">
                                <tr>
                                    <th>USUARIO</th>
                                    <th>ÍTEM</th>
                                    <th class="text-center">CANTIDAD</th>
                                    <th class="text-center">TOTAL PAGADO</th>
                                    <th>APROBADO POR</th>
                                    <th>FECHA DE PAGO</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (request of completedRequests(); track request.requestId) {
                                <tr>
                                    <td>
                                        <div class="fw-semibold">{{ request.requestedByName }}</div>
                                        <div class="small text-muted">{{ request.requestedByEmail }}</div>
                                    </td>
                                    <td>
                                        <div class="fw-semibold">{{ request.itemTitle }}</div>
                                        @if (request.planName) {
                                        <div class="small text-muted">{{ request.planName }}</div>
                                        }
                                    </td>
                                    <td class="text-center">{{ request.quantityRequested | number}}</td>
                                    <td class="text-center">{{ request.reservationPrice | currency }}</td>
                                    <td>{{ request.approvedByEmail || 'N/A' }}</td>
                                    <td>{{ request.paidAt | date : 'dd/MM/yyyy hh:mm a' }}</td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                    @if (completedTotal() > 0) {
                    <app-pagination [page]="completedPage()" [pageSize]="completedPageSize()"
                        [totalItems]="completedTotal()" (pageChange)="onCompletedPageChange($event)"
                        (pageSizeChange)="onCompletedPageSizeChange($event)">
                    </app-pagination>
                    }
                    }
                </div>
                }

                @else if (selectedTab() === 'rejected') {
                <div class="rejected-content">
                    @if (rejectedLoading()) {
                    <div class="d-flex justify-content-center my-4">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Cargando rechazadas...</span>
                        </div>
                    </div>
                    } @else if (rejectedRequests().length === 0) {
                    <div class="empty-state">
                        <i class="fa-solid fa-info-circle me-2"></i>
                        No hay solicitudes rechazadas
                    </div>
                    } @else {
                    <div class="table-responsive">
                        <table class="table table-theme align-middle">
                            <thead class="table-light">
                                <tr>
                                    <th>USUARIO</th>
                                    <th>ÍTEM</th>
                                    <th>RECHAZADO POR</th>
                                    <th>FECHA DE RECHAZO</th>
                                    <th>RAZÓN</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (request of rejectedRequests(); track request.requestId) {
                                <tr>
                                    <td>
                                        <div class="fw-semibold">{{ request.requestedByName }}</div>
                                        <div class="small text-muted">{{ request.requestedByEmail }}</div>
                                    </td>
                                    <td>
                                        <div class="fw-semibold">{{ request.itemTitle }}</div>
                                        @if (request.planName) {
                                        <div class="small text-muted">{{ request.planName }}</div>
                                        }
                                    </td>
                                    <td>{{ request.rejectedByEmail || 'N/A' }}</td>
                                    <td>{{ request.rejectedAt | date : 'dd/MM/yyyy hh:mm a' }}</td>
                                    <td>{{ request.rejectionReason }}</td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                    @if (rejectedTotal() > 0) {
                    <app-pagination [page]="rejectedPage()" [pageSize]="rejectedPageSize()"
                        [totalItems]="rejectedTotal()" (pageChange)="onRejectedPageChange($event)"
                        (pageSizeChange)="onRejectedPageSizeChange($event)">
                    </app-pagination>
                    }
                    }
                </div>
                }

                @else if (selectedTab() === 'expired') {
                <div class="expired-content">
                    @if (expiredLoading()) {
                    <div class="d-flex justify-content-center my-4">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Cargando expiradas...</span>
                        </div>
                    </div>
                    } @else if (expiredRequests().length === 0) {
                    <div class="empty-state">
                        <i class="fa-solid fa-info-circle me-2"></i>
                        No hay solicitudes expiradas
                    </div>
                    } @else {
                    <div class="table-responsive">
                        <table class="table table-theme align-middle">
                            <thead class="table-light">
                                <tr>
                                    <th>USUARIO</th>
                                    <th>ÍTEM</th>
                                    <th>APROBADO POR</th>
                                    <th>FECHA DE EXPIRACIÓN</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (request of expiredRequests(); track request.requestId) {
                                <tr>
                                    <td>
                                        <div class="fw-semibold">{{ request.requestedByName }}</div>
                                        <div class="small text-muted">{{ request.requestedByEmail }}</div>
                                    </td>
                                    <td>
                                        <div class="fw-semibold">{{ request.itemTitle }}</div>
                                        @if (request.planName) {
                                        <div class="small text-muted">{{ request.planName }}</div>
                                        }
                                    </td>
                                    <td>{{ request.approvedByEmail || 'N/A' }}</td>
                                    <td>{{ request.expiresAt | date : 'dd/MM/yyyy hh:mm a' }}</td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                    @if (expiredTotal() > 0) {
                    <app-pagination [page]="expiredPage()" [pageSize]="expiredPageSize()" [totalItems]="expiredTotal()"
                        (pageChange)="onExpiredPageChange($event)" (pageSizeChange)="onExpiredPageSizeChange($event)">
                    </app-pagination>
                    }
                    }
                </div>
                }
            </div>
        </div>
    </div>
</div>